<label class="p-d-block">
    Product
    <div>
        <p-dropdown
                styleClass="w-100"
                [optionLabel]="'name'"
                [(ngModel)]="selectedTemplate"
                [options]="options">
        </p-dropdown>
    </div>
</label>

<ng-container *ngIf="selectedTemplate; let template">
    <ng-container *ngTemplateOutlet="template.template"></ng-container>
</ng-container>

<ng-template pTemplate="Sentinel">
    <div class="p-mb-6"></div>
    <sentinel-provision></sentinel-provision>
</ng-template>